import CryptoJS from "crypto-js";
import { H5_SECRET_KEY, IMG_URL } from "@/config/common";
/**
 * 手机号脱敏处理
 * @param {string} phoneNumber - 原始手机号
 * @returns {string} - 脱敏后的手机号
 */
export function maskPhoneNumber(phoneNumber) {
  const phoneStr = String(phoneNumber);
  if (phoneStr.length !== 11) {
    console.log("无效的手机号");
    return "-";
  }
  return phoneStr.slice(0, 3) + "****" + phoneStr.slice(7);
}

/**
 * 检测图片地址并返回正确的地址
 * @param {string} imgUrl - 图片地址
 * @returns {string} - 处理后的图片地址
 */
export function validateImageUrl(imgUrl) {
  if (!imgUrl) return "";
  // 检查图片地址是否包含http或https
  if (!imgUrl.startsWith("http://") && !imgUrl.startsWith("https://")) {
    // 如果不包含，则使用config中的imgUrl
    return `${IMG_URL}${imgUrl}`;
  }
  // 如果包含，则直接返回图片地址
  return imgUrl;
}

/**
 * 将GPS坐标(WGS84)转换为百度坐标(BD09)
 * 将腾讯、高德地图经纬度转换为百度地图经纬度
 * @param {number} dataLon - 经度值(WGS84坐标系)
 * @param {number} dataLat - 纬度值(WGS84坐标系)
 * @returns {Object} 包含转换后的百度坐标对象
 *   @property {number} bd_lon - 转换后的百度经度
 *   @property {number} bd_lat - 转换后的百度纬度
 */
export function mapPointTxTurnBaiDu(dataLon, dataLat) {
  let bd_lat;
  let bd_lon;
  let x_pi = 3.14159265358979324;
  let x = dataLon,
    y = dataLat;
  let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
  let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
  bd_lon = z * Math.cos(theta) + 0.0065;
  bd_lat = z * Math.sin(theta) + 0.006;
  return { bd_lat, bd_lon };
}

/**
 * 将百度坐标(BD-09)转换为高德坐标(GCJ-02)
 * @param {number} bd_lng 百度坐标经度
 * @param {number} bd_lat 百度坐标纬度
 * @returns {Object} 包含转换后的高德坐标对象 {lon: 经度, lat: 纬度}
 */
export function transPosition(bd_lng, bd_lat) {
  var X_PI = (Math.PI * 3000.0) / 180.0;
  var x = bd_lng - 0.0065;
  var y = bd_lat - 0.006;
  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
  var gg_lng = z * Math.cos(theta);
  var gg_lat = z * Math.sin(theta);
  return { lon: gg_lng, lat: gg_lat };
}

/**
 * aes 加密
 * @param {string}  text  需要加密的字符串
 * @returns {string}
 */
export function Encrypt(text) {
  const encrypt = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(H5_SECRET_KEY), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypt.toString();
}

/**
 * aes 解密
 * @param {string} text 需要解密的字符串
 * @returns {string}
 */
export function Decrypt(text = "") {
  const decrypt = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(text) },
    CryptoJS.enc.Utf8.parse(H5_SECRET_KEY),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    },
  );

  return decrypt.toString(CryptoJS.enc.Utf8);
}

/**
 * 验证是否为有效的URL链接
 * @param {string} url - 待验证的URL字符串
 * @returns {boolean} - 是否为有效链接
 */
export function isValidUrl(url) {
  if (!url || typeof url !== 'string') {
    return false;
  }
  
  try {
    // 使用正则表达式验证URL格式
    const urlPattern = /^(https?|ftp):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/;
    return urlPattern.test(url);
  } catch (e) {
    console.error('URL验证过程中发生错误:', e);
    return false;
  }
}